import React from 'react';

import '../icon-component.scss';

const ToastCrossComponent = () => (
  <svg className="icon-component" viewBox="0 0 12 10">
    <g id="Page-1" stroke="none" fill="none">
      <g transform="translate(1.000000, 0.000000)">
        <path d="M0,0 L10,10" />
        <path d="M0,10 L10,0" />
      </g>
    </g>
  </svg>
);

ToastCrossComponent.displayName = 'ToastCrossIcon';

export default ToastCrossComponent;
